// extracted by mini-css-extract-plugin
export var activeFilterButton = "_hx-c";
export var backButton = "_hx-4";
export var backIcon = "_hx-5";
export var chevronShortcut = "_hx-6";
export var container = "_hx-1";
export var editor = "_hx-8";
export var editorWrapper = "_hx-7";
export var prefix = "_hx-2";
export var searchIcon = "_hx-3";
export var suffix = "_hx-9";
export var suffixContent = "_hx-a";
export var suffixText = "_hx-b";
export var wrapper = "_hx-0";